import React from 'react';
import * as s from './styled-set-point';

const SetPoint = ({
  active,
  onClick,
  icon,
  name,
  type,
  totalVariables,
  disabled,
}) => {
  return (
    <s.Container
      active={active}
      onClick={onClick}
      disabled={disabled}
      type="button"
    >
      <s.LeftWrapper parentActive={active}>
        <img src={icon} alt="" />
      </s.LeftWrapper>
      <s.RightWrapper active={active}>
        <h3>{type}</h3>
        <span>{name}</span>
        {totalVariables ? <h3>{totalVariables} Variáveis</h3> : null}
      </s.RightWrapper>
    </s.Container>
  );
};

export default SetPoint;
